import m from "../../geodata/es2015/bruneiDarussalamHigh";
window.am4geodata_bruneiDarussalamHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bruneiDarussalamHigh.js
// module id = null
// module chunks = 